import toast from "react-hot-toast";
import { useAppServices } from "../../../../../hook/services";
import { useState } from "react";
import { useUserInfo } from "../../../../../context/user";
import { Check } from "@mui/icons-material";

const UpgradePlanModal = ({
  onClose,
  price_id,
  plan,
  paymentMethod_id,
  agency,
}) => {
  const AppService = useAppServices();
  const [loading, setLoading] = useState(false);
  const userActiveLocation = useUserInfo()[4];
  const saveActiveLocation = useUserInfo()[5];

  const handleConfirmClick = async () => {
    setLoading(true);
    const { response: subscription, error } =
      await AppService.subscription.upgradeSubscription({
        payload: {
          agency_id: userActiveLocation?.agency_id,
          price_id,
          plan_id: plan?._id,
          account_id: userActiveLocation?._id,
          paymentMethod_id,
          customer_id: userActiveLocation?.customer_id,
          subscription_id: userActiveLocation?.subscription_id,
          subscription_type: "upgrade",
        },
      });
    if (subscription?.data) {
      saveActiveLocation(subscription.data);
      toast.success("Subscription updated successfully!");
    } else {
      toast.error(error?.message || "Failed to create subscription");
    }
    setLoading(false);
    onClose();
  };
  return (
    <div>
      {/* Title */}
      <h2 className="text-lg font-medium text-center mb-6">
        Confirm Your Upgrade
      </h2>

      {/* Features */}
      <div className="space-y-5">
        <div className="flex items-start gap-3">
          <Check className="text-blue-500 w-5 h-5" />
          <div>
            <p className="font-medium">
              {agency?.upgrade_benefits?.[0] || "More output"}
            </p>
          </div>
        </div>

        <div className="flex items-start gap-3">
          <Check className="text-blue-500 w-5 h-5" />
          <div>
            <p className="font-medium">
              {agency?.upgrade_benefits?.[1] || "Faster results"}
            </p>
          </div>
        </div>

        <div className="flex items-start gap-3">
          <Check className="text-blue-500 w-5 h-5" />
          <div>
            <p className="font-medium">
              {agency?.upgrade_benefits?.[2] || "No data lost"}
            </p>
          </div>
        </div>
      </div>

      {/* Upgrade Button */}
      <button
        onClick={handleConfirmClick}
        disabled={loading}
        className="mt-8 w-full bg-black text-white py-3 rounded-lg hover:bg-gray-800 transition"
      >
        {loading ? "wait..." : "Yes, Upgrade My Plan"}
      </button>
    </div>
  );
};

export default UpgradePlanModal;
